(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accelerated-checkout"] && !Shopify.designMode) return;
  try {
    (function() {
    const buyNowButtons = document.querySelectorAll('[data-buy-now-button]');
    
    buyNowButtons.forEach(function(button) {
      button.addEventListener('click', async function(e) {
        e.preventDefault();
        
        if (button.disabled || button.dataset.loading === 'true') return;
        
        const form = button.closest('form');
        if (!form) return;
        
        // Check form validity
        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }
        
        // Get variant ID
        const variantIdInput = form.querySelector('[ref="variantId"]');
        if (!variantIdInput) return;
        
        const variantId = variantIdInput.value;
        if (!variantId) return;
        
        // Get quantity
        const quantityInput = form.querySelector('[name="quantity"]');
        const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
        
        // Set loading state (prevents multiple clicks without making button look disabled)
        button.dataset.loading = 'true';
        const textSpan = button.querySelector('.buy-now-button__text');
        const loadingSpan = button.querySelector('.buy-now-button__loading');
        
        if (textSpan) textSpan.style.visibility = 'hidden';
        if (loadingSpan) loadingSpan.style.display = 'flex';
        
        try {
          // Add to cart
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: variantId,
              quantity: quantity
            })
          });
          
          if (!response.ok) {
            throw new Error('Failed to add to cart');
          }
          
          // Redirect to checkout
          window.location.href = '/checkout';
        } catch (error) {
          console.error('Buy Now error:', error);
          button.dataset.loading = 'false';
          if (textSpan) textSpan.style.visibility = 'visible';
          if (loadingSpan) loadingSpan.style.display = 'none';
          alert('Unable to add item to cart. Please try again.');
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-ingredients"] && !Shopify.designMode) return;
  try {
    // Immediate log - should appear first (outside IIFE)
  console.log('=== PRODUCT INGREDIENTS SCRIPT STARTING ===');
  console.log('[Product Ingredients] Script file loaded at:', new Date().toISOString());
  
  // Also try alert to verify script is running
  if (typeof window !== 'undefined') {
    console.log('[Product Ingredients] Window object exists');
  }
  
  (function() {
    console.log('[Product Ingredients] Script loaded');
    console.log('[Product Ingredients] URL:', window.location.href);
    console.log('[Product Ingredients] Document ready:', document.readyState);
    
    // Check for block element
    const blockElement = document.querySelector('.product-ingredients');
    console.log('[Product Ingredients] Block element found:', blockElement ? 'YES' : 'NO');
    if (blockElement) {
      console.log('[Product Ingredients] Block visible:', window.getComputedStyle(blockElement).display !== 'none');
    }
    
    const immediateCheck = document.querySelectorAll('[data-ingredients-json]');
    console.log('[Product Ingredients] Found containers with data-ingredients-json:', immediateCheck.length);
    
    if (immediateCheck.length > 0) {
      immediateCheck.forEach(function(el, idx) {
        const jsonAttr = el.getAttribute('data-ingredients-json');
        console.log('[Product Ingredients] Container', idx, 'JSON exists:', jsonAttr ? 'YES' : 'NO');
        if (jsonAttr) {
          console.log('[Product Ingredients] Container', idx, 'JSON length:', jsonAttr.length);
          console.log('[Product Ingredients] Container', idx, 'JSON preview:', jsonAttr.substring(0, 200));
        }
      });
    } else {
      console.warn('[Product Ingredients] NO CONTAINERS FOUND with data-ingredients-json');
      const allIngredients = document.querySelectorAll('.product-ingredients');
      console.warn('[Product Ingredients] Found .product-ingredients elements:', allIngredients.length);
      
      // Check for debug div
      const debugDiv = document.querySelector('.product-ingredients__debug');
      console.log('[Product Ingredients] Debug div found:', debugDiv ? 'YES' : 'NO');
    }
    
    console.log('=== PRODUCT INGREDIENTS INITIAL CHECK COMPLETE ===');
    
    function escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }
    
    function renderRichText(jsonData, container) {
      try {
        console.log('[renderRichText] Starting render, jsonData:', jsonData);
        console.log('[renderRichText] jsonData type:', typeof jsonData);
        console.log('[renderRichText] jsonData keys:', Object.keys(jsonData || {}));
        
        if (!jsonData) {
          console.error('[renderRichText] jsonData is null or undefined');
          container.innerHTML = '<p style="color: red; padding: 16px;">No data to render.</p>';
          return;
        }
        
        if (!jsonData.children || !Array.isArray(jsonData.children)) {
          console.error('[renderRichText] jsonData.children is missing or not an array:', jsonData);
          container.innerHTML = '<p style="color: red; padding: 16px;">Invalid data structure.</p>';
          return;
        }
         
         let html = '<ul class="product-ingredients__list">';
         let allIngredients = [];
         
        // First, collect all ingredients
        jsonData.children.forEach(function(rootChild) {
          console.log('[renderRichText] Processing rootChild:', rootChild.type);
          
          if (rootChild.type === 'list' && rootChild.listType === 'unordered' && rootChild.children) {
            console.log('[renderRichText] Found unordered list with', rootChild.children.length, 'items');
             
             rootChild.children.forEach(function(listItem) {
               if (listItem.type === 'list-item' && listItem.children) {
                 let ingredientHtml = '';
                 let previousWasBold = false;
                 let hasContent = false;
                 
                 listItem.children.forEach(function(itemChild, index) {
                   if (itemChild.type === 'text') {
                     let textValue = itemChild.value || '';
                     let isBold = itemChild.bold === true;
                     
                     if (isBold) {
                       // Remove trailing dash and space from bold text (ingredient name)
                       textValue = textValue.replace(/\s*-\s*$/, '').trim();
                       let escapedText = escapeHtml(textValue);
                       if (escapedText.trim() !== '') {
                         ingredientHtml += '<strong>' + escapedText + '</strong>';
                         hasContent = true;
                       }
                       previousWasBold = true;
                     } else {
                       // Regular text (description)
                       textValue = textValue.trim();
                       let escapedText = escapeHtml(textValue);
                       if (escapedText.trim() !== '') {
                         if (previousWasBold && hasContent) {
                           ingredientHtml += '<br>';
                         }
                         ingredientHtml += escapedText;
                         hasContent = true;
                       }
                       previousWasBold = false;
                     }
                   }
                 });
                 
                if (hasContent) {
                  allIngredients.push(ingredientHtml);
                  console.log('[renderRichText] Added ingredient:', ingredientHtml.substring(0, 50));
                }
              }
            });
          } else {
            console.log('[renderRichText] Skipping rootChild type:', rootChild.type);
          }
        });
        
        console.log('[renderRichText] Total ingredients collected:', allIngredients.length);
        
        if (allIngredients.length === 0) {
          console.warn('[renderRichText] No ingredients found');
          container.innerHTML = '<p style="padding: 16px;">No ingredients found in data.</p>';
          return;
        }
        
        // Render all ingredients in a single row with 5 columns
        // Pattern: Orange | Light | Orange | Light | Orange (alternating)
        allIngredients.forEach(function(ingredientHtml, index) {
          html += '<li class="product-ingredients__item">' + (ingredientHtml || '') + '</li>';
        });
        
        html += '</ul>';
        container.innerHTML = html;
        
        console.log('[renderRichText] Rendered successfully:', allIngredients.length, 'items');
        console.log('[renderRichText] First ingredient:', allIngredients[0]);
      } catch (error) {
        console.error('[renderRichText] Error:', error);
        console.error('[renderRichText] Stack:', error.stack);
        container.innerHTML = '<p style="color: red; padding: 16px;">Error loading ingredients: ' + escapeHtml(error.message) + '</p>';
      }
    }
    
    // Render key ingredients
    function renderKeyIngredients() {
      console.log('[Key Ingredients] Starting renderKeyIngredients');
      const ingredientsContainers = document.querySelectorAll('[data-ingredients-json]');
      console.log('[Key Ingredients] Found containers:', ingredientsContainers.length);
      
      if (ingredientsContainers.length === 0) {
        console.warn('[Key Ingredients] No containers found');
        const allIngredientsElements = document.querySelectorAll('.product-ingredients');
        console.log('[Key Ingredients] Found .product-ingredients elements:', allIngredientsElements.length);
        return;
      }
      
      ingredientsContainers.forEach(function(container, index) {
        console.log('[Key Ingredients] Processing container', index + 1);
        
        // Skip if already rendered (has list inside)
        if (container.querySelector('.product-ingredients__list')) {
          console.log('[Key Ingredients] Already rendered, skipping');
          return;
        }
        
        const jsonString = container.getAttribute('data-ingredients-json');
        const rawString = container.getAttribute('data-ingredients-raw');
        
        console.log('[Key Ingredients] JSON string length:', jsonString ? jsonString.length : 0);
        console.log('[Key Ingredients] JSON string preview:', jsonString ? jsonString.substring(0, 200) : 'empty');
        console.log('[Key Ingredients] JSON string full:', jsonString);
        
        if (!jsonString || jsonString === 'null' || jsonString === 'undefined' || jsonString.trim() === '') {
          console.error('[Key Ingredients] JSON data is empty or invalid');
          console.error('[Key Ingredients] jsonString value:', jsonString);
          
          if (rawString && rawString.trim() !== '') {
            console.log('[Key Ingredients] Using raw string as fallback');
            container.innerHTML = '<p style="padding: 16px;">' + escapeHtml(rawString) + '</p>';
          } else {
            console.error('[Key Ingredients] Both JSON and raw string are empty');
            container.innerHTML = '<p style="color: red; padding: 16px;">Key ingredients data is empty. Check metafield: product.key_ingredients</p>';
          }
          return;
        }
        
        try {
          console.log('[Key Ingredients] Attempting to parse JSON...');
          const jsonData = JSON.parse(jsonString);
          console.log('[Key Ingredients] Successfully parsed JSON');
          console.log('[Key Ingredients] Parsed JSON:', jsonData);
          renderRichText(jsonData, container);
          console.log('[Key Ingredients] Rendered successfully');
        } catch (e) {
          console.error('[Key Ingredients] Error parsing JSON:', e.message);
          console.error('[Key Ingredients] JSON string that failed:', jsonString);
          
          // Fallback to raw text
          if (rawString && rawString.trim() !== '') {
            console.log('[Key Ingredients] Using raw string as fallback after parse error');
            container.innerHTML = '<p style="padding: 16px;">' + escapeHtml(rawString) + '</p>';
          } else {
            console.error('[Key Ingredients] No fallback available');
            container.innerHTML = '<p style="color: red; padding: 16px;">Error loading key ingredients. Check console for details.</p>';
          }
        }
      });
    }
    
    // Run on DOM ready with retries
    function initKeyIngredients() {
      renderKeyIngredients();
    }
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initKeyIngredients);
    } else {
      initKeyIngredients();
    }
    
    // Retry after delays
    setTimeout(initKeyIngredients, 500);
    setTimeout(initKeyIngredients, 1000);
    setTimeout(initKeyIngredients, 2000);
    
    // Listen for Shopify theme editor events
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:section:load', initKeyIngredients);
      document.addEventListener('shopify:block:select', initKeyIngredients);
    }
    
    // Handle full ingredients toggle
    const toggleButtons = document.querySelectorAll('[data-full-ingredients-toggle]');
    toggleButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        const content = button.nextElementSibling;
        if (!content || !content.hasAttribute('data-full-ingredients-json')) {
          console.error('Full ingredients content container not found');
          return;
        }
        
        const isExpanded = button.getAttribute('aria-expanded') === 'true';
        
        if (isExpanded) {
          content.style.display = 'none';
          button.setAttribute('aria-expanded', 'false');
        } else {
          // Render content if not already rendered
          if (content.innerHTML.trim() === '') {
            try {
              const jsonString = content.getAttribute('data-full-ingredients-json');
              const rawString = content.getAttribute('data-full-ingredients-raw');
              
              if (!jsonString || jsonString === 'null' || jsonString === 'undefined' || jsonString.trim() === '') {
                console.error('Full ingredients JSON data is empty. Raw value:', rawString);
                // Try to display raw value if JSON is empty
                if (rawString && rawString !== 'null' && rawString !== 'undefined' && rawString.trim() !== '') {
                  content.innerHTML = '<div class="product-ingredients__content">' + escapeHtml(rawString) + '</div>';
                } else {
                  content.innerHTML = '<p>Full ingredients data not available.</p>';
                }
              } else {
                const jsonData = JSON.parse(jsonString);
                if (jsonData && jsonData.children && Array.isArray(jsonData.children) && jsonData.children.length > 0) {
                  // It's a rich text structure
                  renderRichText(jsonData, content);
                } else if (jsonData && typeof jsonData === 'string') {
                  // It's a plain string
                  content.innerHTML = '<div class="product-ingredients__content">' + escapeHtml(jsonData) + '</div>';
                } else if (jsonData && Object.keys(jsonData).length > 0) {
                  // Try to render it anyway
                  renderRichText(jsonData, content);
                } else {
                  console.error('Full ingredients JSON data is invalid:', jsonData);
                  // Fallback to raw value
                  if (rawString && rawString !== 'null' && rawString !== 'undefined' && rawString.trim() !== '') {
                    content.innerHTML = '<div class="product-ingredients__content">' + escapeHtml(rawString) + '</div>';
                  } else {
                    content.innerHTML = '<p>Full ingredients data format is invalid.</p>';
                  }
                }
              }
            } catch (error) {
              console.error('Error parsing full ingredients JSON:', error);
              // Fallback to raw value
              const rawString = content.getAttribute('data-full-ingredients-raw');
              if (rawString && rawString !== 'null' && rawString !== 'undefined' && rawString.trim() !== '') {
                content.innerHTML = '<div class="product-ingredients__content">' + escapeHtml(rawString) + '</div>';
              } else {
                content.innerHTML = '<p>Error loading full ingredients. Please check the console for details.</p>';
              }
            }
          }
          content.style.display = 'block';
          button.setAttribute('aria-expanded', 'true');
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
